// extracted by mini-css-extract-plugin
export default {"floatingButton":"Floating_floatingButton__K1SS7","whatsapp":"Floating_whatsapp__IfqQI","phone":"Floating_phone__2E88f"};